import React, { useMemo } from "react";
import JoditEditor from "jodit-react";

const RichTextEditor = ({ content, setContent, placeholder, setFocus }) => {
  const config = useMemo(
    () => ({
      placeholder: placeholder,
      buttons: ['bold', 'italic', 'underline', 'ul', 'ol', 'link'],
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      minHeight: 200,
      width: "96.7%",
      uploader: {
        insertImageAsBase64URI: true,
      },
    }),
    [placeholder]
  );

  const handleBlur = (newContent) => {
    const cleanedContent = newContent.trim() === "<p><br></p>" ? "" : newContent;
    setContent(cleanedContent);
  };


  return (
    <div onClick={() => setFocus(true)}>
      <JoditEditor
        value={content}
        config={config}
        tabIndex={1}
        onBlur={handleBlur}
        onChange={() => {}}
      />
    </div>
  );
};
export default RichTextEditor;
